class MarketsSelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.currentMarketSpan = this.querySelector('[data-current-market]');
    this.marketsJson = this.querySelector('[data-markets-json]');
    this.markets = [];
    this.currentMarket = null;
  }

  connectedCallback() {
    try {
      this.markets = JSON.parse(this.marketsJson.textContent);
    } catch (error) {
      console.error('Error parsing markets JSON:', error);
      return;
    }

    this.form.addEventListener('click', this.onMarketSelect.bind(this));
    this.form.addEventListener('keydown', this.onKeyDown.bind(this));
    this.updateCurrentMarket();
  }

  updateCurrentMarket() {
    const currentUrl = new URL(window.location.href);
    const currentHostname = currentUrl.hostname;
        
    this.currentMarket = this.markets.find(market => market.base_url === currentHostname) || this.markets.find(market => market.base_url === '');
    
    if (this.currentMarket) {
      this.currentMarketSpan.textContent = this.currentMarket.title;
      this.form.querySelectorAll('button[name="market_handle"]').forEach(button => {
        button.setAttribute('aria-selected', button.value === this.currentMarket.base_url ? 'true' : 'false');
      });
    }
  }

  onMarketSelect(event) {
    const clickedButton = event.target.closest('button[name="market_handle"]');
    if (!clickedButton) return;

    event.preventDefault();
    this.changeMarket(clickedButton.value);
  }

  onKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      const focusedButton = event.target.closest('button[name="market_handle"]');
      if (focusedButton) {
        event.preventDefault();
        this.changeMarket(focusedButton.value);
      }
    }
  }

  changeMarket(baseUrl) {
    const currentUrl = new URL(window.location.href);
    const newUrl = new URL(currentUrl.pathname + currentUrl.search, 'https://' + baseUrl);
    
    const event = new CustomEvent('marketChange', { 
      detail: { newMarket: baseUrl, newUrl: newUrl.toString() },
      bubbles: true
    });
    
    this.dispatchEvent(event);
    
    console.log('redirecting to...', newUrl.toString());

    window.location.href = newUrl.toString();
  }
}

if (!window.customElements.get('markets-selector')) {
  customElements.define('markets-selector', MarketsSelector);
}